<template>
  <section class="content">
    <!-- Default box -->
    <div class="box mt-2">
            <div class="box-header">
              <h3 class="box-title" v-if="!showDetails"><b>Consolidated TA Members</b></h3>
              <h3 class="box-title" v-if="showDetails"><b>Details</b></h3>
              <hr>
            </div>
            <!-- /.box-header -->
            <div class="box-body" style="min-height: 800px;height: auto;">
              <div id="example1_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                <div class="row" v-if="!showDetails">
                  <div class="col-sm-12">
                    <!-- <div class="box-header with-border" style="background-color: #f1f1f1;">Detailed List</div> -->
                    <div class="box-header with-border" style="padding: 11px;padding-right: 0px;">
                      <div v-on:click="chartView = !chartView" class="box-title" style="padding-left: 0px; color: grey; font-size:14px;">
                        <span v-if="chartView == false" @click="getChart()"><i class="fa fa-bar-chart" aria-hidden="true"></i> Chart View</span>
                        <span v-if="chartView == true"><i class="fa fa-table" aria-hidden="true"></i> Table View </span>
                      </div>
                      <!-- <h3 class="box-title"></h3> -->
                      <div v-if="chartView" class="box-tools d-flex flex-row justify-content-between align-items-center">
                        <div class="box-tools" style="width: 600px;">
                          <Datepicker
                            v-model="selectedDate" lang="en"
                            range/>
                          <button class="mr-2 btn btn-sm btn-default pull-right" @click="clearData()">Clear</button>
                          <button class="mr-2 btn btn-sm sbtn pull-right" @click="getDate()">Apply</button>
                          <div>
                            <span  class="form-select pull-right">
                              <select class="form-control" @change="getChart()" style=" height: 32px; width: 175px; margin-right: 10px; margin-left: 10px;" v-model="postsort">
                                <option v-for="(x, index) in userslist" :key="index" :value="x.tamember_first_name + ' ' + x.tamember_last_name">{{x.tamember_first_name + ' ' + x.tamember_last_name}}</option>
                              </select>
                              <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-if="!chartView"  class="box-tools" style="width: 500px;">
                        <Datepicker
                        v-model="selectedDate" position="right" lang="en"
                        range/>
                        <div>
                          <export-excel name="consolidate-ta-member-metrics" :data="json_data">
                            <a href="javascript:void(0)" @click="open()" class="btn btn-sm btn-primary pull-right">Export</a>
                          </export-excel>
                          <button class="mr-2 btn btn-sm sbtn pull-right" @click="getDate()">Apply</button>
                          <button class="mr-2 btn btn-sm btn-default pull-right" @click="clearData()">Clear</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div style="margin-top: 20%;text-align:center" v-if="userslistlength < 1">
                      <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <div  v-if="!chartView"  class="table-responsive text-nowrap">
                  <table v-if="userslistlength > 0" id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px">
                <thead>
                  <tr role="row" class="tc">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;"></th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">TA Member's</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Schedule</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">Candidate</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">Panel</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Cancelled</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Client</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Client</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending"></th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Scheduled</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Submission</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Interview</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Offer</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Offer</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Schedule</th>
                  </tr>
                  <tr role="row" class="tc">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;">S.No</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Set up</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Rescheduled</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">No Show</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">No show</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Proxy</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Rejected</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">By TA</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Submission</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Interview</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Offered</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">To Join</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Declined</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Joined</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">vs Submission(%)</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">vs Interview(%)</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">vs Offer(%)</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">vs Declined(%)</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">vs Joined(%)</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">vs Joined(%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="row" class="odd tc" v-for="(x, index) in userslist" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td style="text-align: left;">{{x.tamember_first_name}} {{x.tamember_last_name}}</td>
                    <td><a @click="showDetail(x.org_user_id, 'setup')">{{x.schedule_setup_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'reschedule')">{{x.reschedule_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'candidate_no_show')">{{x.candidate_no_show_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'panel_no_show')">{{x.panel_no_show_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'proxy')">{{x.of_proxy_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'rejected')">{{x.rejected_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'cancel_by_ta')">{{x.cancelled_by_ta_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'client_submission')">{{x.client_submission_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'client_interview')">{{x.client_interview_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'offered')">{{x.offered_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'to_join')">{{x.to_join_count }}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'declined')">{{x.declined_count}}</a></td>
                    <td><a @click="showDetail(x.org_user_id, 'joined')">{{x.joined_count}}</a></td>
                    <td>{{x.sch_submission_percentage}}%</td>
                    <td>{{x.submission_interview_percentage}}%</td>
                    <td>{{x.sch_interview_offer_percentage}}%</td>
                    <td>{{x.offer_decline_percentage}}%</td>
                    <td>{{x.offer_joined_percentage}}%</td>
                    <td>{{x.sch_sch_joined_percentage}}%</td>
                  </tr>
                  <tr role="row" class="odd tc" v-if="grandTotal.length > 0" style="background-color: #1d1c1c;color: white;">
                    <td>#</td>
                    <td>Grand Total</td>
                    <td>{{grandTotal[0].sum_schedule_setup_count}}</td>
                    <td>{{grandTotal[0].sum_reschedule_count}}</td>
                    <td>{{grandTotal[0].sum_candidate_no_show_count}}</td>
                    <td>{{grandTotal[0].sum_panel_no_show_count}}</td>
                    <td>{{grandTotal[0].sum_of_proxy_count}}</td>
                    <td>{{grandTotal[0].sum_rejected_count}}</td>
                    <td>{{grandTotal[0].sum_cancelled_by_ta_count}}</td>
                    <td>{{grandTotal[0].sum_client_submission_count}}</td>
                    <td>{{grandTotal[0].sum_client_interview_count}}</td>
                    <td>{{grandTotal[0].sum_offered_count}}</td>
                    <td>{{grandTotal[0].to_join_count}}</td>
                    <td>{{grandTotal[0].sum_declined_count}}</td>
                    <td>{{grandTotal[0].sum_joined_count}}</td>
                    <td>{{grandTotal[0].sum_sch_submission_percentage}}</td>
                    <td>{{grandTotal[0].sum_submission_interview_percentage}}</td>
                    <td>{{grandTotal[0].sum_sch_interview_offer_percentage}}</td>
                    <td>{{grandTotal[0].sum_offer_decline_percentage}}</td>
                    <td>{{grandTotal[0].sum_offer_joined_percentage}}</td>
                    <td>{{grandTotal[0].sum_sch_sch_joined_percentage}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
              <!-- v-if="chartView" -->
              <div style="width:100%" class="col-md-12 row" v-show="chartView && userslistlength > 0" >
                <div  class="col-md-2"></div>
                <div  class="col-md-7" style="width:500px; height: 300px; text-align:center; display:flex; align-items: center;">
                  <canvas id="planetchart" width="400" height="250"></canvas>
                </div>
                <div class="col-md-3">
                  <div class="d-flex flex-column align-items-center"  style="width:500px; height: 400px; text-align:start ; margin-top:100px">
                    <div><span><i class="fa fa-square" style="color:#68f748;"></i> &nbsp;&nbsp; Scheduled Vs Submission(%)</span></div>
                    <div><span><i class="fa fa-square" style="color:#f7da48;"></i> &nbsp;&nbsp; Submission Vs Interview(%)</span></div>
                    <div><span><i class="fa fa-square" style="color:#f25416;"></i> &nbsp;&nbsp; Interview Vs Offer(%)</span></div>
                    <div><span><i class="fa fa-square" style="color:#0fffbb;"></i> &nbsp;&nbsp; Offer Vs Declined(%)</span></div>
                    <div><span><i class="fa fa-square" style="color:#e30fff;"></i> &nbsp;&nbsp; Offer Vs Joined(%)</span></div>
                    <div><span><i class="fa fa-square" style="color:#ff0f53;"></i> &nbsp;&nbsp; Schedule Vs joined(%)</span></div>
                  </div>
                </div>
              </div>
              </div></div>
              <!-- start detao;s -->
              <div class="row mt-2" v-if="showDetails">
                <div class="col-sm-12">
                  <!-- <div class="box-header with-border" style="background-color: #f1f1f1;">Detailed List</div> -->
                  <div class="box-header with-border" style="padding: 11px;padding-right: 0px;">
                    <h3 class="box-title"></h3>
                    <div class="box-tools" style="width: 500px;">
                      <div>
                        <button class="mr-2 btn btn-sm sbtn pull-right" @click="closeDetail()">Back</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 p-1">
                  <div class="col-md-12">
                    <h3 class="tc" v-if="taDetails.length < 1">No Data found</h3>
                    <table v-if="taDetails.length > 0" class="report-tabl" border="0" style="width: 100%;border: 1px solid #252424b8 !important;font-size: 12px;">
                      <tr style="background-color: aliceblue;height: 32px;text-align: center;">
                        <td><b>S.No</b></td>
                        <td><b>Role Name</b></td>
                        <td><b>Candidate First Name</b></td>
                        <td><b>Candidate Last Name</b></td>
                        <td><b>Interviewer First Name</b></td>
                        <td><b>Interviewer Last Name</b></td>
                        <td><b>Interview Date</b></td>
                        <td><b>Interview Time</b></td>
                        <td><b>Recommended(Yes/No)</b></td>
                      </tr>
                      <tr style="height: 30px;text-align: center;" v-for="(x, index) in taDetails" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{x.role_name}}</td>
                        <td>{{x.candidate_name}}</td>
                        <td>{{x.candidate_lastname}}</td>
                        <td>{{x.interviewer_first_name}}</td>
                        <td>{{x.interviewer_last_name}}</td>
                        <td>{{x.interview_date | formatDate}}</td>
                        <td>{{x.interview_start_time}} - {{x.interview_end_time}}</td>
                        <td>{{x.recommended}}</td>
                      </tr>
                    </table>
                    <br><br>
                    <p>&nbsp;</p>
                  </div>
                  <!-- <div style="float: right;padding: 10px;" v-if="taDetails.length > 0">
                    <button type="button" class="btn btn-success" @click="closeDetail()">Back</button>
                  </div> -->
                </div>
              </div>
              <!-- end details -->
              <!-- <div class="row" v-if="totalPages > 9">
                <div class="col-sm-3">
                  <div class="dataTables_info" id="example1_info" role="status" aria-live="polite"></div>
                </div>
                <div class="col-sm-7">
                  <jw-pagination :items="pages" @changePage="onChangePage"></jw-pagination>
                </div>
                </div> -->
              </div>
            </div>
            <!-- /.box-body -->
            <div class="modal overlay fade in" id="myModal1">
              <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
                <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
                  <div class="modal-body" style="padding:0px">
                    <div class="row" >
                      <div class="col-md-12 " style="padding:17px">
                        <div class="col-md-12" style="text-align: center;">
                          <p style="font-size: 20px;font-weight: 600;">Candidate No Show</p><br>
                          <button class="btn btn-success" @click="closeViolated()">Ok</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
            </div>
          </div>
  </section>
</template>

<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import excel from 'vue-excel-export'
import router from '../../router/index'
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination'
import $ from 'jquery'
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import moment from 'moment'
import Chart from 'chart.js'
// Register
Vue.component('Datepicker', VueDatepickerUi)
Vue.component('jw-pagination', JwPagination)
Vue.use(excel)
export default {
  name: 'tabs-card',
  data () {
    return {
      title: '',
      pageOfItems: [],
      totalPages: 0,
      pages: [],
      showlist: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      viewdetails: false,
      showRole: false,
      adduser: true,
      userslistlength: '',
      userslist: [],
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      json_data: [],
      postdetails: [],
      grandTotal: [],
      email: '',
      base_urls: BaseURL,
      selectedDate: [],
      disabledEndDate: {
        to: new Date('01.02.2221'),
        from: new Date(new Date().getDate() + 1)
      },
      startDate: '',
      endDate: '',
      taDetails: [],
      showDetails: false,
      chartView: false,
      chart_data: null,
      chart_config: null,
      myChart: null,
      postsort: null
    }
  },
  components: {
    Datepicker: VueDatepickerUi
  },
  created () {
    this.getPostdata()
    this.email = this.userInfo.user_email
    this.$root.$emit('navigate', 'Report')
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
  },
  methods: {
    getChart () {
      var ind = this.userslist.findIndex((e) => e.tamember_first_name + ' ' + e.tamember_last_name === this.postsort)
      if (window.myChart instanceof Chart) {
        console.log('enter ', window.myChart)
        window.myChart.destroy()
      }
      $('#planetchart').replaceWith($('<canvas id="planetchart" width="400" height="250"></canvas>'))
      var exampleChart = new Chart('planetchart', {
        type: 'bar',
        data: {
          labels: [''],
          datasets: [
            {
              label: 'Scheduled Submission',
              type: 'bar',
              data: [
                this.userslist[ind].sch_submission_percentage
              ],
              backgroundColor: '#68f748',
              borderWidth: 0
            },
            {
              label: ' Submission Vs Interview(%)',
              type: 'bar',
              data: [
                this.userslist[ind].submission_interview_percentage
              ],
              backgroundColor: '#f7da48',
              borderWidth: 0
            },
            {
              label: 'Interview Vs Offer(%)',
              type: 'bar',
              data: [
                this.userslist[ind].sch_interview_offer_percentage
              ],
              backgroundColor: '#f25416',
              borderWidth: 0
            },
            {
              label: 'Offer Vs Declined(%)',
              type: 'bar',
              data: [
                this.userslist[ind].offer_decline_percentage
              ],
              backgroundColor: '#0fffbb',
              borderWidth: 0
            },
            {
              label: 'Offer Vs Joined(%)',
              type: 'bar',
              data: [
                this.userslist[ind].offer_joined_percentage
              ],
              backgroundColor: '#e30fff',
              borderWidth: 0
            },
            {
              label: 'Schedule Vs joined(%)',
              type: 'bar',
              data: [
                this.userslist[ind].sch_sch_joined_percentage
              ],
              backgroundColor: '#ff0f53',
              borderWidth: 0
            }
          ]
        },
        options: {
          legend: {
            display: false
          },
          responsive: true,
          lineTension: 0.1,
          title: {
            display: true,
            text: this.postsort
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      // exampleChart.update()
      console.log('exampleChart1', exampleChart)
    },
    getDate (e) {
      this.startDate = moment(this.selectedDate[0]).format('YYYY-MM-DD')
      this.endDate = moment(this.selectedDate[1]).format('YYYY-MM-DD')
      this.getPostdata()
    },
    clearData () {
      this.selectedDate = []
      this.startDate = ''
      this.endDate = ''
      this.getPostdata()
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    openViolated () {
      $('#myModal1').modal('show')
    },
    showDetail (id, type) {
      const data = {
        org_user_id: id,
        type: type,
        from_date: this.startDate,
        to_date: this.endDate,
        skip: 0
      }
      const mainurl = '/dashboard/get_consolidated_ta_detail_acs'
      axios.post(`${BaseURL}${mainurl}`, { formData: data }, this.config).then(response => {
        this.taDetails = response.data.consolidated_ta_detail
      }).catch(e => {
        console.log(e)
      })
      this.showDetails = true
    },
    closeDetail () {
      this.showDetails = false
    },
    getPostdata () {
      const data = {
        from_date: this.startDate,
        to_date: this.endDate,
        skip: 0
      }
      const mainurl = '/dashboard/get_acs_consolidated_ta_report'
      axios.post(`${BaseURL}${mainurl}`, { formData: data }, this.config).then(response => {
        this.userslist = response.data.acs_consolidated_ta_report
        this.userslistlength = response.data.acs_consolidated_ta_report.length
        if (this.userslistlength > 0) {
          this.postsort = this.userslist[0].tamember_first_name + ' ' + this.userslist[0].tamember_last_name
        } else {
          this.postsort = null
        }
        this.grandTotal = response.data.acs_consolidated_ta_report_grandtotal
        this.json_data = this.userslist
        this.json_data = this.json_data.map(item => {
          return {
            ta_member: item.tamember_first_name + ' ' + item.tamember_last_name,
            set_up: item.schedule_setup_count,
            reschedule: item.reschedule_count,
            candidate_no_show: item.candidate_no_show_count,
            panel_no_show: item.panel_no_show_count,
            proxy: item.of_proxy_count,
            rejected: item.rejected_count,
            cancelled_by_ta: item.cancelled_by_ta_count
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    },
    viewFeedback (id) {
      const route = router.resolve({ name: 'Viewfeedback', params: { id: id } })
      window.open(route.href, '_blank')
    }
  }

}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
hr {
  margin-top: 9px;
  margin-bottom: 9px;
}
.tc {
  text-align: center;
}
.table>thead>tr>th {
    border: 1px solid #f4f4f4;
    text-align: center;
}
.table>tbody>tr>td {
    border: 1px solid #f4f4f4;
    text-align: center;
}
.report-tabl>tbody>td>th {
  font-size: 12px !important;
}
td, th {
  padding: 0;
  border: 1px solid #ccc !important;
}
</style>
